import React from 'react';

const ResetButton = (props) => (
  <button type="button" {...props} className="button is-outlined reset-button">
    {/* <span className="icon is-small">
      <i className="mi mi-close" />
    </span> */}
    <span>Reset</span>
  </button>
);

export default ResetButton;
